import {ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output, ViewChild} from '@angular/core';
import {PerfectScrollbarConfigInterface} from 'ngx-perfect-scrollbar';
import {Router} from "@angular/router";
import {AuthService} from '../../shared-component/service/auth/auth.service';
import {LoanService} from '../../shared-component/service/loan/loan.service';
import {CustomerService} from '../../shared-component/service/customer/customer.service';
import { DOCUMENT } from '@angular/common';
import { SessionExpiryService } from '../../shared-component/session-expiry-service/session-expiry.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ToasterAlertService } from '../../shared-component/notification/toastAlert.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'ap-navigation',
  styleUrls: ['./navigation.component.scss'],
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};
  public profileData: any = {};
  public changePasswordMessage: any = false;
  public userImage: any = null;
  public elem;
  public isFullscreenActive = false;
  public passwordForm: FormGroup;
  public patternErrorShown: boolean = false;
  public inputValue: any = "";
  public systemType : any = environment.production;
  public profilePic: any = null;
  
  @Output() myEvent = new EventEmitter();
  @ViewChild('popup') popUp: any;

  constructor(
    private router: Router,
    private auth: AuthService,
    private loanService: LoanService,
    private modalService: NgbModal,
    public fb: FormBuilder,
    public toasterService: ToasterAlertService,
    private customerService: CustomerService,
    private sessionExpiryService: SessionExpiryService,
    @Inject(DOCUMENT) private document: any,
    private cdr: ChangeDetectorRef
  ) {
    this.passwordForm = this.fb.group({
      newpassword: ['', Validators.compose([Validators.required,Validators.minLength(8),Validators.maxLength(32), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$#*@&%])\S{8,32}$/)])],
      confirmPassword: ['', Validators.compose([Validators.required, Validators.minLength(8),Validators.maxLength(32), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$#*@&%])\S{8,32}$/)])],
    },{ validator: this.passwordMatchValidator() }
    );
  }

  ngOnInit() {
    this.profilePic = this.customerService.getProfilePic();
    this.customerService.profile().subscribe((res: any) => {
      this.profileData = res.data;
        // this.customerService.getIdProofPathS3Customer(this.profiledata.id).subscribe((res: any) => {
        //   this.userImage = res.data.signed.photoPath;
        // });
        if (this.profileData.passwordChangeRequired) {
          this.openPopup();
        }
    });
    this.elem = document.documentElement;
    document.addEventListener('fullscreenchange', () => this.checkFullScreenStatus());
    document.addEventListener('mozfullscreenchange', () => this.checkFullScreenStatus());
    document.addEventListener('webkitfullscreenchange', () => this.checkFullScreenStatus());
    document.addEventListener('msfullscreenchange', () => this.checkFullScreenStatus());
    this.checkFullScreenStatus();

    this.loadProfilePic( );

    let oThat = this;
    if( !this.profilePic ){
      setTimeout(function(){
        oThat.profilePic = oThat.customerService.getProfilePic();
      },100);
      setTimeout(function(){
        oThat.profilePic = oThat.customerService.getProfilePic();
      },1000);
    }
  }

  loadProfilePic( ){
    this.customerService.loadProfilePic( ).subscribe( (res : any) =>{
      if( res.data){
        this.customerService.setProfilePic(res.data.url);
        this.profilePic = res.data.url;
      }  
    });
  }

  openPopup() {
    let oThat = this;
    this.changePasswordMessage = false;
    this.modalService.open(this.popUp, {
      backdrop: 'static',
      beforeDismiss: () => {
        oThat.changePasswordMessage = false
        return !oThat.profileData.passwordChangeRequired;
      }
    });
  }

  // logout() {
  //   sessionStorage.removeItem('token');
  //   this.sessionExpiryService.clear();
  //   this.router.navigate(['/authentication']).then();
  // }

  logout() {
    this.auth.logout().subscribe( (res : any) => {
      sessionStorage.removeItem('token');
      this.sessionExpiryService.clear();
      this.toasterService.pop('success', '', res.message);
      this.router.navigate(['/authentication']).then();
    },
      (errors) => {
        this.toasterService.pop('error', '', errors);
        close()
    });
  }

  goToProfile() {
    this.router.navigate(['/profile']);
  }

  toggleSidebar() {
    this.myEvent.emit();
  }

  checkFullScreenStatus() {
    if (document.fullscreenElement) {
      this.isFullscreenActive = true;
    } else {
      this.isFullscreenActive = false;
    }
  }

  openFullscreen() {
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }

  /* Close fullscreen */
  closeFullscreen() {
    if (document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      /* Firefox */
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      /* IE/Edge */
      this.document.msExitFullscreen();
    }
  }

  onInputChange(event: any) {
    this.inputValue = event.target.value;
    if (this.passwordForm.get('confirmPassword').hasError('pattern')) {
        this.patternErrorShown = true;
    } else {
        this.patternErrorShown = false;
    }
    return null;
  }

  get password() {
    return this.passwordForm.get('newpassword');
  }

  get confirmPassword() {
    return this.passwordForm.get('confirmPassword');
  }

  changePassword() {
    if (this.passwordForm.valid && this.passwordForm.get('newpassword').value === this.passwordForm.get('confirmPassword').value) {
      this.auth.changePassword(this.passwordForm.value).subscribe((res:any) => {
        this.changePasswordMessage = true;
        this.toasterService.pop('success', '', res.message);
      }, (errors) => {
        for (let error of errors) {
          if (!this.passwordForm.get(error.field)) continue;
          this.passwordForm.get(error.field).setErrors({ server: error.message });
        }
      });
    } else {
      this.toasterService.pop('error', '', 'Passwords does not match');
    }
  }

  passwordMatchValidator(): ValidatorFn {
    return (formGroup: FormGroup): ValidationErrors | null => {
      const passwordControl = formGroup.get('password');
      const confirmPasswordControl = formGroup.get('confirmPassword');
  
      if (passwordControl && confirmPasswordControl && passwordControl.value !== confirmPasswordControl.value) {
        confirmPasswordControl.setErrors({ matchPassword: true });
        return { matchPassword: true };
      } else {
        confirmPasswordControl.setErrors(null);
        return null;
      }
    };
  }

}
